import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import api from "../utilis/api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { login, logout } from "../redux/store/userSlice";
import { LoginModal, RegisterModal } from "./Modals";
const LANGUAGES = [
  { label: "English (USD)", code: "en", currency: "USD" },
  { label: "French (EUR)", code: "fr", currency: "EUR" },
  { label: "Arabic (AED)", code: "ar", currency: "AED" },
];

const Topbar = () => {
  const barRef = useRef(null);
  const modalRef = useRef(null);
  const overlayRef = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("login"); // "login" | "register"
  const [langOpen, setLangOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(LANGUAGES[0]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn, user } = useSelector((state) => state.user);

  /* ── Topbar entrance ── */
  useEffect(() => {
    gsap.fromTo(
      barRef.current,
      { y: -50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
    );
  }, []);

  /* ── Modal open animation ── */
  useEffect(() => {
    if (!isModalOpen) return;
    gsap.set(overlayRef.current, { opacity: 0 });
    gsap.set(modalRef.current, { scale: 0.85, opacity: 0, y: 20 });
    gsap.to(overlayRef.current, { opacity: 1, duration: 0.3 });
    gsap.to(modalRef.current, {
      scale: 1,
      opacity: 1,
      y: 0,
      duration: 0.45,
      ease: "back.out(1.6)",
    });
  }, [isModalOpen]);

  const openModal = (tab = "login") => {
    setActiveTab(tab);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    gsap.to(overlayRef.current, { opacity: 0, duration: 0.25 });
    gsap.to(modalRef.current, {
      scale: 0.85,
      opacity: 0,
      y: 16,
      duration: 0.3,
      onComplete: () => setIsModalOpen(false),
    });
  };

  const handleLangSelect = (lang) => {
    setSelectedLang(lang);
    setLangOpen(false);
  };

  /* ── Shared styles ── */

  //  handle login

  return (
    <>
      {/* ── TOPBAR ── */}
      <div
        ref={barRef}
        style={{
          position: "relative",
          width: "100%",
          padding: "10px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "linear-gradient(to right, #e5cf94, #fffdf5, #b38f36)",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          boxSizing: "border-box",
          flexWrap: "wrap",
          gap: "8px",
          zIndex: 50,
        }}
      >
        {/* Left message */}
        <p
          style={{
            fontSize: "13px",
            fontWeight: 500,
            color: "#1a1a1a",
            margin: 0,
          }}
        >
          Free U.S Shipping — Over 40 million orders shipped
        </p>

        {/* Right actions */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            fontSize: "13px",
          }}
        >
          {/* Language dropdown */}
          <div style={{ position: "relative" }}>
            <button
              onClick={() => setLangOpen((o) => !o)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                color: "#1a1a1a",
              }}
            >
              {selectedLang.label}
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>

            {langOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "calc(100% + 8px)",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #e5e5e5",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                  minWidth: "170px",
                  zIndex: 100,
                }}
              >
                {LANGUAGES.map((lang) => (
                  <button
                    key={lang.code}
                    onClick={() => handleLangSelect(lang)}
                    style={{
                      display: "block",
                      width: "100%",
                      textAlign: "left",
                      padding: "10px 16px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "13px",
                      color:
                        lang.code === selectedLang.code ? "#b38f36" : "#1a1a1a",
                      fontWeight: lang.code === selectedLang.code ? 600 : 400,
                      transition: "background 0.15s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#faf6ee")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "none")
                    }
                  >
                    {lang.label}
                    {lang.code === selectedLang.code && " ✓"}
                  </button>
                ))}
              </div>
            )}
          </div>

          <span style={{ color: "#aaa" }}>|</span>

          {/* Auth buttons - show only when not logged in */}
          {!isLoggedIn ? (
            <>
              <button
                onClick={() => openModal("login")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                Login
              </button>
              <span style={{ color: "#aaa" }}>or</span>
              <button
                onClick={() => openModal("register")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                Register
              </button>
            </>
          ) : (
            <>
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#1a1a1a",
                }}
              >
                Welcome, {user?.name || user?.email || 'User'}
              </span>
              <span style={{ color: "#1a1a1a" }}>|</span>
              <button
                onClick={() => {
                  dispatch(logout({ scope: "customer" }));
                  toast.success("Logged out successfully");
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#1a1a1a",
                }}
              >
                Logout
              </button>
            </>
          )}
        </div>
      </div>

      {/* Close lang dropdown on outside click */}
      {langOpen && (
        <div
          style={{ position: "fixed", inset: 0, zIndex: 49 }}
          onClick={() => setLangOpen(false)}
        />
      )}

      {/* ── AUTH MODAL ── */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          {/* Overlay */}
          <div
            ref={overlayRef}
            onClick={closeModal}
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.55)",
              backdropFilter: "blur(4px)",
            }}
          />

          {/* Modal */}
          <div
            ref={modalRef}
            style={{
              position: "relative",
              zIndex: 1,
              background: "#fff",
              borderRadius: "16px",
              width: "100%",
              maxWidth: "420px",
              padding: "32px",
              boxShadow: "0 24px 60px rgba(0,0,0,0.2)",
            }}
          >
            {/* Close */}
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "20px",
                color: "#888",
                lineHeight: 1,
              }}
            >
              ×
            </button>

            {/* Tabs */}
            <div
              style={{
                display: "flex",
                borderBottom: "1px solid #eee",
                marginBottom: "24px",
              }}
            >
              {["login", "register"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    flex: 1,
                    background: "none",
                    border: "none",
                    padding: "10px 0",
                    cursor: "pointer",
                    fontSize: "15px",
                    fontWeight: 600,
                    textTransform: "capitalize",
                    color: activeTab === tab ? "#b38f36" : "#aaa",
                    borderBottom:
                      activeTab === tab
                        ? "2px solid #b38f36"
                        : "2px solid transparent",
                    marginBottom: "-1px",
                    transition: "color 0.2s",
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* LOGIN */}
            {activeTab === "login" && <LoginModal setTab={setActiveTab} onClose={closeModal} />}

            {/* REGISTER */}
            {activeTab === "register" && (
              <RegisterModal setTab={setActiveTab} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Topbar;
